// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-form-item {
  width: 100%;
}
.custom-form-item .ant-form-item {
  margin-bottom: 0;
}
.custom-form-item .ant-row {
  margin-left: 0px !important;
  margin-right: 0px !important;
  display: block;
}
.custom-form-item .ant-row .ant-form-item-label {
  text-align: left;
}
.custom-form-item .ant-row .ant-form-item-label label {
  color: #000;
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  letter-spacing: 0em;
}
.custom-form-item label::before {
  content: none !important;
}
@media (max-width: 1024px) {
  .custom-form-item label {
    font-size: 18px;
  }
}
@media (min-width: 481px) and (max-width: 767px) {
  .custom-form-item .ant-row .ant-form-item-label {
    padding-bottom: 0;
  }
  .custom-form-item label {
    font-size: 14px;
  }
}
@media (min-width: 280px) and (max-width: 480px) {
  .custom-form-item .ant-row .ant-form-item-label {
    padding-bottom: 0;
  }
  .custom-form-item label {
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/UiComponents/CustomFormItem/CustomFormItem.less"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;AAFA;EAGI,gBAAA;AAEJ;AALA;EAMI,2BAAA;EACA,4BAAA;EACA,cAAA;AAEJ;AAVA;EAUM,gBAAA;AAGN;AAbA;EAYQ,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAIR;AACI;EACE,wBAAA;AACN;AAIA;EACE;IAEI,eAAA;EAHJ;AACF;AAqCA;EACE;IAGM,iBAAA;EArCN;EAkCA;IAOI,eAAA;EAtCJ;AACF;AA4CA;EACE;IAGM,iBAAA;EA5CN;EAyCA;IAOI,eAAA;EA7CJ;AACF","sourcesContent":[".custom-form-item {\n  width: 100%;\n  .ant-form-item {\n    margin-bottom: 0;\n  }\n  .ant-row {\n    margin-left: 0px !important;\n    margin-right: 0px !important;\n    display: block;\n    .ant-form-item-label {\n      text-align: left;\n      label {\n        color: #000;\n        font-size: 14px;\n        font-weight: 500;\n        line-height: 1;\n        letter-spacing: 0em;\n      }\n    }\n  }\n  label {\n    &::before {\n      content: none !important;\n    }\n  }\n}\n\n@media (max-width: 1024px) {\n  .custom-form-item {\n    label {\n      font-size: 18px;\n    }\n  }\n}\n\n// MEDIA QUERY START\n\n// ##Device = HD Desktops\n// ##Screen = 1600px to higher resolution desktops\n\n@media screen and (min-width: 1600px) {\n} //  Dont delete this bracket!\n\n// ##Device = Desktops\n// ##Screen = 1281px to higher resolution desktops\n@media (min-width: 1281px) and (max-width: 1599px) {\n} //  Dont delete this bracket!\n\n// ##Device = Laptops, Desktops\n// ##Screen = B/w 1025px to 1280px\n@media (min-width: 1025px) and (max-width: 1280px) {\n} //  1025px to 1280px (Laptops, Desktops) Dont delete this bracket!\n\n// ##Device = Tablets, Ipads (landscape)\n// ##Screen = B/w 768px to 1024px\n@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\n} //  768px to 1024px (landscape) Dont delete this bracket!\n\n// ##Device = Tablets, Ipads (portrait)\n// ##Screen = B/w 768px to 1024px\n@media (min-width: 768px) and (max-width: 1024px) {\n} //  768px to 1024px (portrait) Dont delete this bracket!\n\n// ##Device = Low Resolution Tablets, Mobiles (Landscape)\n// ##Screen = B/w 481px to 767px\n@media (min-width: 481px) and (max-width: 767px) {\n  .custom-form-item {\n    .ant-row {\n      .ant-form-item-label {\n        padding-bottom: 0;\n      }\n    }\n    label {\n      font-size: 14px;\n    }\n  }\n} //  481px to 767px (Landscape) Dont delete this bracket!\n\n// ##Device = Most of the Smartphones Mobiles (Portrait)\n// ##Screen = B/w 280px to 480px\n@media (min-width: 280px) and (max-width: 480px) {\n  .custom-form-item {\n    .ant-row {\n      .ant-form-item-label {\n        padding-bottom: 0;\n      }\n    }\n    label {\n      font-size: 14px;\n    }\n  }\n} //  280px to 480px (Portrait) Dont delete this bracket!\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
